import {
    getRentAllListRequest,
    getRentAllRequest,
} from '../../../../services/network/rent/all';

class CommonRentAllService {
    async getRentAllList(payload) {
        return await getRentAllListRequest(payload);
    }

    async getRentAll(id) {
        return await getRentAllRequest(id);
    }
}

export const RentAllService = new CommonRentAllService();
